// language=GraphQL
export const ALL_USERS_QUERY = `query Query($withRole: Boolean = false, $withRolePermissions: Boolean = false) {
  users: users {
    id
    email
    firstName
    lastName
    role @include(if: $withRole) {
      id
      name
      description
      permissions @include(if: $withRolePermissions) {
        id
        path
        module
        name
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_USER_QUERY = `query Query($id: ID!, $withRole: Boolean = false, $withRolePermissions: Boolean = false) {
  user: user(id: $id) {
    id
    email
    firstName
    lastName
    role @include(if: $withRole) {
      id
      name
      description
      permissions @include(if: $withRolePermissions) {
        id
        path
        module
        name
      }
    }
  }
}`

// language=GraphQL
export const CREATE_USER_MUTATION = `
  mutation Mutation($input: CreateUserInput, $withRole: Boolean = false, $withRolePermissions: Boolean = false) {
    user: createUser(input: $input) {
      id
      email
      firstName
      lastName
      role @include(if: $withRole) {
        id
        name
        description
        permissions @include(if: $withRolePermissions) {
          id
          path
          module
          name
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_USER_MUTATION = `
  mutation Mutation($input: UpdateUserInput, $withRole: Boolean = false, $withRolePermissions: Boolean = false) {
    user: updateUser(input: $input) {
      id
      email
      firstName
      lastName
      role @include(if: $withRole) {
        id
        name
        description
        permissions @include(if: $withRolePermissions) {
          id
          path
          module
          name
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_USER_MUTATION = `
  mutation Mutation($input: DeleteUserInput) {
    deleteUser(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_USER_MUTATION = `
  mutation Mutation($input: DeleteUserInput) {
    forceDeleteUser(input: $input) {
      success
    }
  }`
